// extracted by mini-css-extract-plugin
export var active = "component-module--active--16f79";
export var anchorNavigation = "component-module--anchorNavigation--eb832";
export var anchorNavigationContent = "component-module--anchorNavigationContent--8014b";
export var bottom = "component-module--bottom--d69f5";
export var button = "component-module--button--8024a";
export var infoText = "component-module--infoText--7e5a8";
export var name = "component-module--name--b3178";
export var price = "component-module--price--f1ecf";